import { EYE_TEST_ID } from "./constants";

// Haversine formula to calculate the distance between two points (in km)
export const haversineDistance = (coords1, coords2) => {
  const toRad = (value) => (value * Math.PI) / 180;

  const lat1 = coords1.lat;
  const lon1 = coords1.lng;
  const lat2 = coords2.lat;
  const lon2 = coords2.lng;

  const R = 6371; // Radius of the Earth in km
  const dLat = toRad(lat2 - lat1);
  const dLon = toRad(lon2 - lon1);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(toRad(lat1)) *
      Math.cos(toRad(lat2)) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const distance = R * c; // Distance in km
  return distance;
}


// Function to format date in YYYY-MM-DD format
export const formatDate = (date) => {
  if(!date) return ""
  return date.toLocaleDateString('en-CA') // 'en-CA' gives you the YYYY-MM-DD format
}


export const formatDateLong = (dateString) => {

  const date = new Date(dateString)

  const dayOptions = { weekday: 'long' } // For 'Tuesday'
  const dayOfMonth = date.getDate() // For '12'

  // Format the ordinal day (e.g., '12th')
  const ordinalDay = dayOfMonth + (dayOfMonth % 10 === 1 && dayOfMonth !== 11 ? 'st' : (dayOfMonth % 10 === 2 && dayOfMonth !== 12 ? 'nd' : (dayOfMonth % 10 === 3 && dayOfMonth !== 13 ? 'rd' : 'th')))

  const monthOptions = { month: 'long' } // For 'November'
  const yearOptions = { year: 'numeric' } // For '2024'

  const day = date.toLocaleDateString('en-GB', dayOptions) // Outputs 'Tuesday'
  const month = date.toLocaleDateString('en-GB', monthOptions) // Outputs 'November'
  const year = date.toLocaleDateString('en-GB', yearOptions) // Outputs '2024'

  return `${day} ${ordinalDay} ${month} ${year}`
}

export const formatDateLong_cancel = (dateString) => {

  const date = new Date(dateString)

  const dayOptions = { weekday: 'long' } // For 'Tuesday'
  const dayOfMonth = date.getDate() // For '12'

  // Format the ordinal day (e.g., '12th')
  const ordinalDay = dayOfMonth + (dayOfMonth % 10 === 1 && dayOfMonth !== 11 ? 'st' : (dayOfMonth % 10 === 2 && dayOfMonth !== 12 ? 'nd' : (dayOfMonth % 10 === 3 && dayOfMonth !== 13 ? 'rd' : 'th')))

  const monthOptions = { month: 'long' } // For 'November'
  const yearOptions = { year: 'numeric' } // For '2024'

  const day = date.toLocaleDateString('en-GB', dayOptions) // Outputs 'Tuesday'
  const month = date.toLocaleDateString('en-GB', monthOptions) // Outputs 'November'
  const year = date.toLocaleDateString('en-GB', yearOptions) // Outputs '2024'

  return `${day}, ${month} ${ordinalDay}`
}



export const getTimeDifferenceInMinutes = (startTime, endTime) => {
  if (!startTime || !endTime) return 0;

  // Parse the times into Date objects on the same arbitrary date
  const today = "1970-01-01"; // arbitrary same date
  const start = new Date(`${today}T${convertTo24Hour(startTime)}`);
  const end = new Date(`${today}T${convertTo24Hour(endTime)}`);

  // Difference in milliseconds
  const diffMs = end - start;
  // Convert to minutes
  return diffMs / 1000 / 60;
}

// Helper to convert "11:40 AM" to 24-hour "11:40:00"
const convertTo24Hour = (timeStr) => {
  const [time, modifier] = timeStr.split(" ");
  let [hours, minutes] = time.split(":");
  if (modifier === "PM" && hours !== "12") hours = parseInt(hours, 10) + 12;
  if (modifier === "AM" && hours === "12") hours = 0;
  return `${hours.toString().padStart(2,'0')}:${minutes}:00`;
}

export const formatDateLong_new = (dateString) => {
  const date = new Date(dateString);

  const dayOptions = { weekday: 'long' };      // 'Friday'
  const dayOfMonth = date.getDate();            // 15 (no ordinal suffix)
  const monthOptions = { month: 'long' };      // 'August'
  const yearOptions = { year: 'numeric' };     // '2025'

  const day = date.toLocaleDateString('en-GB', dayOptions);    // Friday
  const month = date.toLocaleDateString('en-GB', monthOptions); // August
  const year = date.toLocaleDateString('en-GB', yearOptions);   // 2025

  // Return with commas after weekday and year, no ordinal suffix:
  return `${day}, ${dayOfMonth} ${month} ${year}`;
}



export const formatLocation = (location) => {
  const street = location.PIAB__Street__c           // Street address
  const city = location.PIAB__City__c               // City
  const state = location.PIAB__State__c             // State
  const postalCode = location.PIAB__Postal_Code__c  // Postal code

  // Combine into a formatted string
  return `${street}, ${city} ${state} ${postalCode}`
}


export const formatTestType = (testType) => {
  if(testType === EYE_TEST_ID) return "Eye Test"
  return "Contact Lenses"
}


export const formatCustomerName = (customer) => {
  return `${customer.firstName} ${customer.lastName}`
}


export const formatPhoneNumber = (phoneNumber) => {
  // Assuming the phone number is 10 digits long
  return phoneNumber.replace(/(\d{4})(\d{3})(\d{3})/, "$1 $2 $3")
}

export const getAssetUrl = (path) => {
  return (window.reactAppBaseUrl || '') + path
}